/**
 * The class website's address for one course on one day — the student-facing version of the
 * lesson, holding only the cards marked "Show Card on Class Website". The route is
 * `/student-lesson/:course_id/:date_string` (frontend/app/router.js).
 *
 * Both places that hand this link out — the lesson menu's Share Link view and the card menu's
 * class-website callout — build it here, so they can never drift.
 */
export function studentLessonUrl(courseId: string, dateString: string): string {
  const { protocol, host } = window.location
  return `${protocol}//${host}/student-lesson/${courseId}/${dateString}`
}
